module.exports = __webpack_public_path__ + "files/683eb8a18831f6d0ceede5714fe51edf.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/code_themes/solarized-dark.png
// module id = 1256
// module chunks = 60